module.exports = __webpack_public_path__ + "static/poster-10a3753d594e4095c8d6386f2259ef15.png";